import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'Mobile Apps',
      en: 'Mobile Apps'
    },
    description: {
      de: 'Professionelle Mobile App-Entwicklung für Ihr Unternehmen - Native und Cross-Platform.',
      en: 'Professional mobile app development for your business - Native and cross-platform.'
    }
  }
}); 